import React, { useCallback } from 'react';
import messages from './messages';
import Cookies from 'js-cookie';

import SentimentVeryDissatisfiedIcon from './SentimentVeryDissatisfiedIcon.svg';
import RefreshIcon from './RefreshIcon.svg';

import useStyles from './sheet';

const locales = Cookies.get('locale') || '{}';

function parseLocales() {
  try {
    const { locale } = JSON.parse(locales);

    switch (locale) {
      case 'en':
      case 'uk':
        return 'en';
      default:
        return locale;
    }
  } catch (error) {
    console.error('error parsing locales', error);
    return 'en';
  }
}

const SWWPage = () => {
  const locale = parseLocales();
  const classes = useStyles();

  const handleClick = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <div className={classes.container}>
      <img src={SentimentVeryDissatisfiedIcon} alt="SentimentVeryDissatisfied" />
      <h5 className={classes.title}>{messages[locale].title}</h5>
      <div className={classes.subtitle}>{messages[locale].subtitle}</div>

      <button className={classes.button} onClick={handleClick}>
        <img className={classes.icon} src={RefreshIcon} alt="refresh icon" />
        {messages[locale].button}
      </button>
    </div>
  );
};

export default SWWPage;
